module.exports = __webpack_public_path__ + "3-64.jpg?8c1a6edc223118563ee78aead0e0c95f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-64.jpg
// module id = 146
// module chunks = 0